import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CreatableSelect from 'react-select/creatable';
import selectCss from '../../../../components/widgets/ReactSelectOverrides.css';
import { filterSpecialChars } from './conditionUtils';
import css from './style.css';

const MENU_PORTAL_TARGET = typeof document !== 'undefined' ? document.body : undefined;

const normalize = values =>
    Array.isArray(values) ? values : values !== null && values !== undefined && values !== '' ? [values] : [];

const sanitize = raw => {
    const trimmed = filterSpecialChars(String(raw), true).trim();
    if (trimmed === '') return null;
    return Number.isNaN(+trimmed) ? trimmed : +trimmed;
};

const CustomMultiValueInput = ({ values = [], invalid = false, disabled = false, translate, editCondition }) => {
    const resolvedValues = useMemo(
        () =>
            normalize(values).map(value => {
                const plain = value && typeof value === 'object' ? value.value : value;
                return { label: String(plain), value: plain };
            }),
        [values]
    );

    const handleChange = selected => {
        const plain = (selected || []).map(option => sanitize(option.value)).filter(value => value !== null);
        // de-dupe while preserving order
        editCondition(
            'values',
            plain.filter((value, index) => plain.indexOf(value) === index)
        );
    };

    return (
        <CreatableSelect
            className={classNames(selectCss.singularSelect, css.conditionSelect, css.fill, {
                [selectCss.error]: invalid,
            })}
            classNamePrefix="Select"
            isDisabled={disabled}
            isMulti
            isClearable={false}
            value={resolvedValues}
            options={[]}
            onChange={handleChange}
            formatCreateLabel={inputValue => inputValue}
            noOptionsMessage={() => null}
            placeholder={translate('STATIC.PAGES.FRAUD.CUSTOM_RULES.CUSTOM_VALUE_PLACEHOLDER')}
            menuPortalTarget={MENU_PORTAL_TARGET}
        />
    );
};

CustomMultiValueInput.propTypes = {
    values: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        PropTypes.string,
        PropTypes.number,
    ]),
    invalid: PropTypes.bool,
    disabled: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    editCondition: PropTypes.func.isRequired,
};

export default CustomMultiValueInput;
